import BaseEnum from '@linc-technologies/linced-common/enums/base-enum';

export default BaseEnum.create({
  values: [
    { value: 0, label: 'Unspecified' },
    { value: 1, label: 'Pending Enrolment' },
    { value: 2, label: 'Enrolled' },
    { value: 3, label: 'Pending Unenrolment' },
    { value: 4, label: 'Unenrolled' },
  ],
});
